navigator.BrowserDetect = (function() {
  var M, tem, ua;
  ua = navigator.userAgent;
  tem = void 0;
  M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem != null) {
      return "Opera " + tem[1];
    }
  }
  M = (M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]);
  return M.splice(0, 1);
})();

